import { i18n } from '../plugins/i18n'
import { allSitesConst } from './sitesConst'
import { camelCase } from './string_converter'

export const displayAllPrefix = 'display-'

export const decimalPlace = 1

export const npsList = [
  {
    id: 'promoters',
    color: '#4C959A',
  },
  {
    id: 'passives',
    color: '#D2D5DB',
  },
  {
    id: 'detractors',
    color: '#E9446A',
  },
]

export const crossAnalysisTypes = [
  {
    id: 'store',
    name: i18n.t('models.analysis.crossAnalysisTypes.store.name'),
    fields: 'store_id',
  },
  {
    id: 'site',
    name: i18n.t('models.analysis.crossAnalysisTypes.site.name'),
    fields: 'site_type',
  },
  {
    id: 'brand',
    name: i18n.t('models.analysis.crossAnalysisTypes.brand.name'),
    fields: 'brand_id',
  },
  {
    id: 'franchisee',
    name: i18n.t('models.analysis.crossAnalysisTypes.franchisee.name'),
    fields: 'franchisee_id',
  },
  {
    id: 'areaManager',
    name: i18n.t('models.analysis.crossAnalysisTypes.areaManager.name'),
    fields: 'user_company_id',
  },
  {
    id: 'prefecture',
    name: i18n.t('models.analysis.crossAnalysisTypes.prefecture.name'),
    fields: 'prefecture',
  },
  {
    id: 'area',
    name: i18n.t('models.analysis.crossAnalysisTypes.area.name'),
    fields: 'area_id',
  }
]

export const reviewDataTypes = [
  {
    id: 'scores',
    name: i18n.t('models.analysis.analysisTypes.scores.name'),
    text: i18n.t('models.analysis.analysisTypes.scores.text'),
    dataType: 'average_scores_graph_elements',
  },
  {
    id: 'counts',
    name: i18n.t('models.analysis.analysisTypes.counts.name'),
    text: i18n.t('models.analysis.analysisTypes.counts.text'),
    dataType: 'posted_counts_per_rating_graph_elements',
  },
  {
    id: 'totalCounts',
    name: i18n.t('models.analysis.analysisTypes.totalCounts.name'),
    text: i18n.t('models.analysis.analysisTypes.totalCounts.text'),
    dataType: 'total_posted_counts_graph_elements',
  },
]

export const qscaDataTypes = [
  {
    id: 'quality',
    name: i18n.t('models.analysis.qscaDataTypes.quality.name'),
    text: i18n.t('models.analysis.qscaDataTypes.quality.text'),
    dataType: 'quality_graph_elements',
  },
  {
    id: 'service',
    name: i18n.t('models.analysis.qscaDataTypes.service.name'),
    text: i18n.t('models.analysis.qscaDataTypes.service.text'),
    dataType: 'service_graph_elements',
  },
  {
    id: 'cleanliness',
    name: i18n.t('models.analysis.qscaDataTypes.cleanliness.name'),
    text: i18n.t('models.analysis.qscaDataTypes.cleanliness.text'),
    dataType: 'cleanliness_graph_elements',
  },
  {
    id: 'atmosphere',
    name: i18n.t('models.analysis.qscaDataTypes.atmosphere.name'),
    text: i18n.t('models.analysis.qscaDataTypes.atmosphere.text'),
    dataType: 'atmosphere_graph_elements',
  },
]

export const keywordAnalysisTypes = [
  {
    id: 'store',
    name: i18n.t('pages.companies.analysis.keywords.tab.store'),
  },
  {
    id: 'competitor',
    name: i18n.t('pages.companies.analysis.keywords.tab.competitor'),
  },
  {
    id: 'specifyKeywordsComparison',
    name: i18n.t('pages.companies.analysis.keywords.tab.specifyKeywordsComparison'),
  },
  {
    id: 'frequentKeywordsComparison',
    name: i18n.t('pages.companies.analysis.keywords.tab.frequentKeywordsComparison'),
  },
]

export const keywordComparisonAnalysisTypes = [
  {
    id: 'storeComparison',
    name: i18n.t('pages.companies.analysis.keywords.labels.comparison.tab.storeComparison'),
  },
  {
    id: 'brandComparison',
    name: i18n.t('pages.companies.analysis.keywords.labels.comparison.tab.brandComparison'),
  },
]

export const visitorsTypes = [
  {
    id: 'lpPvs',
    name: i18n.t('models.analysis.visitorsTypes.lpPvs.name'),
    text: i18n.t('models.analysis.visitorsTypes.lpPvs.text'),
    dataType: 'lp_pvs',
  },
  {
    id: 'likeCount',
    name: i18n.t('models.analysis.visitorsTypes.likeCount.name'),
    text: i18n.t('models.analysis.visitorsTypes.likeCount.text'),
    dataType: 'like_count',
  },
  {
    id: 'dislikeCount',
    name: i18n.t('models.analysis.visitorsTypes.dislikeCount.name'),
    text: i18n.t('models.analysis.visitorsTypes.dislikeCount.text'),
    dataType: 'dislike_count',
  },
  {
    id: 'surveyAnswerCount',
    name: i18n.t('models.analysis.visitorsTypes.surveyAnswerCount.name'),
    text: i18n.t('models.analysis.visitorsTypes.surveyAnswerCount.text'),
    dataType: 'survey_answer_count',
  },
  ...allSitesConst.map(siteConst => {
    return {
      id: camelCase(siteConst.siteType) + 'ImpressionCount',
      name: i18n.t('models.analysis.visitorsTypes.impressionCount.name', { siteType: siteConst.name }),
      text: i18n.t('models.analysis.visitorsTypes.impressionCount.text', { siteType: siteConst.name }),
      dataType: siteConst.siteType + '_impression_count'
    }
  })
]


export const periods = [
  {
    id: 'day',
    name: i18n.t('labels.date.day')
  },
  {
    id: 'week',
    name: i18n.t('labels.date.week')
  },
  {
    id: 'month',
    name: i18n.t('labels.date.month')
  },
]

export const colors = [
  '#E9446A', '#058DC7', '#E97753', '#1FAE6A', '#F4B400',
  '#5FB0BA', '#AFAFAF', '#AB9831', '#8B6BA4', '#C7718E',
]

export const colorNumbers = [
  '233, 68, 106', '5, 141, 199', '233, 119, 83', '31, 174, 106', '244, 180, 0',
  '95, 176, 186', '175, 175, 175', '171, 152, 49', '139, 107, 164', '199, 113, 142'
]

export const stackedBarColorNumbers = [
  ['210, 213, 219', '252, 232, 237', '247, 191, 204', '243, 150, 171', '238, 109, 139', '233, 68, 106'],
  ['210, 213, 219', '215, 242, 254', '151, 222, 252', '86, 201, 251', '21, 181, 249', '5, 141, 199'],
  ['210, 213, 219', '252, 233, 228', '249, 216, 205', '243, 183, 164', '238, 151, 124','233, 119, 83'],
  ['210, 213, 219', '208, 247, 228', '178, 241, 211', '117, 230, 177', '57, 220, 142', '31, 174, 106'],
  ['210, 213, 219', '255, 236, 183', '255, 229, 157', '255, 215, 101', '255, 200, 45', '244, 180, 0',],
  ['210, 213, 219', '223, 239, 241', '191, 223, 227', '159, 208, 214', '127, 192, 200', '95, 176, 186'],
  ['210, 213, 219', '246, 246, 246', '229, 229, 229', '211, 211, 211', '193, 193, 193', '175, 175, 175'],
  ['210, 213, 219', '245, 241, 220', '231, 222, 172', '218, 203, 125', '204, 184, 77', '171, 152, 49'],
  ['210, 213, 219', '238, 233, 242', '213, 202, 222', '188, 170, 203', '164, 139, 183', '139, 107, 164'],
  ['210, 213, 219', '245, 230, 235', '234, 201, 212', '222, 172, 189', '211, 142, 165', '199, 113, 142']
]

export const stackedBarTwoStepsColorNumbers = [
  ['244, 164, 182', '233, 68, 106'],
  ['111, 209, 251', '5, 141, 199'],
  ['247, 208, 196', '233, 119, 83'],
  ['126, 232, 182', '31, 174, 106'],
  ['255, 225, 142', '244, 180, 0'],
  ['177, 216, 221', '95, 176, 186'],
  ['221, 221, 221', '175, 175, 175'],
  ['224, 213, 148', '171, 152, 49'],
  ['198, 183, 211', '139, 107, 164'],
  ['228, 186, 200', '199, 113, 142'],
]
export const stackedBarThreeStepsColorNumbers = [
  ['249, 205, 215', '241, 136, 161', '233, 68, 106'],
  ['205, 239, 254', '81, 200, 251', '5, 141, 199'],
  ['249, 219, 210', '241, 169, 146', '233, 119, 83'],
  ['169, 240, 206', '83, 224, 157', '31, 174, 106'],
  ['255, 233, 173', '255, 209, 81', '244, 180, 0'],
  ['202, 229, 232', '148, 202, 209', '95, 176, 186'],
  ['231, 231, 231', '203, 203, 203', '175, 175, 175'],
  ['234, 225, 180', '212, 195, 105', '171, 152, 49'],
  ['228, 221, 234', '184, 164, 199', '139, 107, 164'],
  ['251, 245, 247', '225, 179, 194', '199, 113, 142'],
]

export const stackedBarFourStepsColorNumbers = [
  ['251, 219, 226', '245, 168, 186', '239, 118, 146', '233, 68, 106'],
  ['195, 236, 253', '116, 211, 251', '36, 186, 249', '5, 141, 199'],
  ['250, 226, 219', '245, 191, 173', '239, 155, 128', '233, 119, 83'],
  ['191, 244, 219', '126, 232, 182', '61, 220, 145', '31, 174, 106'],
  ['255, 241, 203', '255, 223, 132', '255, 204, 60', '244, 180, 0'],
  ['223, 239, 241', '180, 218, 223', '138, 197, 204', '95, 176, 186'],
  ['236, 236, 236', '216, 216, 216', '195, 195, 195', '175, 175, 175'],
  ['242, 236, 208', '224, 213, 148', '207, 189, 89', '171, 152, 49'],
  ['228, 221, 234', '198, 183, 211', '169, 145, 187', '139, 107, 164'],
  ['242, 223, 229', '228, 186, 200', '213, 150, 171', '199, 113, 142'],
]

export const gmbInsightDataTypes = [
  {
    name: i18n.t('models.analysis.gmbInsightDataTypes.view'),
    data: [
      {
        id: 'businessImpressions',
        dataKey: 'business_impressions_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressions.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressions.text'),
      },
      {
        id: 'businessImpressionsDesktopSearch',
        dataKey: 'business_impressions_desktop_search_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressionsDesktopSearch.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressionsDesktopSearch.text'),
      },
      {
        id: 'businessImpressionsMobileSearch',
        dataKey: 'business_impressions_mobile_search_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressionsMobileSearch.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressionsMobileSearch.text'),
      },
      {
        id: 'businessImpressionsDesktopMaps',
        dataKey: 'business_impressions_desktop_maps_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressionsDesktopMaps.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressionsDesktopMaps.text'),
      },
      {
        id: 'businessImpressionsMobileMaps',
        dataKey: 'business_impressions_mobile_maps_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressionsMobileMaps.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessImpressionsMobileMaps.text'),
      },
    ]
  },
  {
    name: i18n.t('models.analysis.gmbInsightDataTypes.response'),
    data: [
      {
        id: 'microConversions',
        dataKey: 'micro_conversions_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.microConversions.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.microConversions.text'),
      },
      {
        id: 'websiteClicks',
        dataKey: 'website_clicks_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.websiteClicks.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.websiteClicks.text'),
      },
      {
        id: 'businessDirectionRequests',
        dataKey: 'business_direction_requests_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessDirectionRequests.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessDirectionRequests.text'),
      },
      {
        id: 'callClicks',
        dataKey: 'call_clicks_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.callClicks.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.callClicks.text'),
      },
    ],
  },
  {
    name: i18n.t('models.analysis.gmbInsightDataTypes.otherResponse'),
    data: [
      {
        id: 'businessBookings',
        dataKey: 'business_bookings_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessBookings.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessBookings.text'),
      },
      {
        id: 'businessConversations',
        dataKey: 'business_conversations_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessConversations.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessConversations.text'),
      },
      {
        id: 'businessFoodOrders',
        dataKey: 'business_food_orders_graph_elements',
        name: i18n.t('models.analysis.gmbInsightDataTypes.businessFoodOrders.name'),
        text: i18n.t('models.analysis.gmbInsightDataTypes.businessFoodOrders.text'),
      },
    ]
  }
]

/**
 * 分析の表（テーブル）の一行目のfields以外のデータを計算し、生成する
 * @param aggs
 * @returns {{scores: string, counts: Number, totalCounts: Number}}
 */
export function makeAggregateOfAll(aggs) {
  const totalScore = aggs.reduce((acc, current) => acc + Number(current.totalScores), 0)
  const counts = aggs.reduce((acc, current) => acc + Number(current.counts), 0)
  const counts_without_rating_null = aggs.reduce((acc, current) => acc + Number(current.counts_without_rating_null), 0)
  const totalCounts = aggs.reduce((acc, current) => acc + Number(current.totalCounts), 0)
  let averageScores = counts_without_rating_null !== 0 ? totalScore / counts_without_rating_null : 0
  averageScores = (Math.round(averageScores * 10) / 10).toPrecision(2) // 小数第二位を四捨五入
  return {
    scores: averageScores,
    counts: counts,
    totalCounts: totalCounts,
  }
}

/**
 * 分析のグラフの評価毎のカウント数を比率に変換
 * FIXME: 使用していない? 使用していないなら消したい。
 */
export function transformCountToRatio(elements) {
  return Object.values(elements).map((e) => {
    const totalCount = Object.values(e).reduce((a, b) => a + b, 0)
    return Object.keys(e).reduce((map, k) => {
      map[k] = totalCount === 0 ? 0 : (e[k] / totalCount) * 100
      map[k] = Math.floor(map[k] * 10) / 10
      return map
    }, {})
  })
}

export function formatQsca(qsca) {
  let isDataEnough = true
  const requiredTotalCount = 10
  qscaDataTypes.forEach(type => {
    let qscaData = qsca[type.id]
    if (qscaData.totalCount <= requiredTotalCount) {
      isDataEnough = false
    }
    qsca[type.id] = qsca[type.id].score
  })
  qsca.isDataEnough = isDataEnough
  return qsca
}

export const generateGraphId = (graph) => {
  const prefix = graph.parent_analysis_axis ? 'competitor-' : ''
  const id = graph.fields
    .map(field => `${ field.key }-${ field.id }`)
    .join('|')
  return prefix + id
}

/**
 * 分析のテーブルの言語別軸のレコードの順番
 */
export const localeOrders = ['ja', 'en', 'zhtw', 'zhcn', 'ko', 'th', 'others']
